$(document).ready(function () {

    // Home page - featured collection slider start
    $('.homepage-sections-wrapper [data-wetheme-section-id]').each(function () {
        new Swiper($(this).find('.swiper-slider'), {
            nextButton: $(this).find('.swiper-button-next'),
            prevButton: $(this).find('.swiper-button-prev'),
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 20,
            paginationClickable: true,
            breakpoints: {
                1028: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                },
                767: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 8
                },
                580: {
                    slidesPerView: 1.43,
                    slidesPerGroup: 1,
                    spaceBetween: 8
                }
            }
        });
    });
    // Home page - featured collection slider end

    // Home page - testimonial slider start
    new Swiper('.flexslider-container-testimonial .swiper-container', {
        nextButton: '.testimonial-swiper-buttons .swiper-button-next',
        prevButton: '.testimonial-swiper-buttons .swiper-button-prev',
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
        paginationClickable: true,
        breakpoints: {
            580: {
                slidesPerView: 1.43,
                slidesPerGroup: 1,
                spaceBetween: 8,
            },
            767: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 8,
            }
        }
    });
    // Home page - testimonial slider end

    // Home page - announcement slider start

    $(".notification-bar__message .owl-carousel").owlCarousel({
        loop: true,
        autoplay: true,
        items: 1,
        autoplayTimeout: 10000,
        nav: false,
        dots: false,
        animateOut: 'fadeOut'
    });
    // new Swiper('.notification-bar__message.swiper-container', {
    //    // slidesPerView: 1,
    //    autoplay: {
    //       delay: 8000,
    //    },
    //    loop: true,
    //    speed: 5000,
    //    // effect: 'fade',
    //    // direction: 'vertical',
    //    // direction: 'horizontal',
    //    // nextButton: '.testimonial-swiper-buttons .swiper-button-next',
    //    // prevButton: '.testimonial-swiper-buttons .swiper-button-prev',
    //    // paginationClickable: true,
    //    // autoplay: true,
    //    // breakpoints: {
    //    //     480: {
    //    //         slidesPerView: 1
    //    //     }
    //    // }
    // });
    // Home page - announcement slider end

    if ($(window).width() >= 768) {
        // Home page - collection list slider start
        // new Swiper('.template-index .collection-grid.swiper-container', {
        //    slidesPerView: 4,
        //    spaceBetween: 20,
        // });
        // Home page - collection list slider end

        // Add overlay for the active menu start
        setTimeout(function () {
            $('li.gm-level-0.desktop_menu').on('mouseenter', function () {
                $('body').addClass('menu-overlay');
            });
            $('li.gm-level-0.desktop_menu').on('mouseleave', function () {
                $('body').removeClass('menu-overlay');
            });
        }, 2000);
        // Add overlay for the active menu end

        // sameHeight($('.indiv-product .indiv-product-title-text'));
        // $('.homepage-featured-products').each(function() {
        //    sameHeight($(this).find('.indiv-product-title-text'));
        //  });

      $('.search-show.header-link.header-link--button').on('click', function() {
          $('.top-search input').focus();
      });
    }

    // Collection page - collection list slider start
    new Swiper('.template-collection .collection-grid', {
        nextButton: '.template-collection .collection-grid .swiper-button-next',
        prevButton: '.template-collection .collection-grid .swiper-button-prev',
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 20,
        // paginationClickable: true,
        // centeredSlides: false,
        breakpoints: {
            580: {
                slidesPerView: 1.8,
                slidesPerGroup: 1,
                centeredSlides: true,
                loop: true,
                loopAdditionalSlides: 50,
            },
            767: {
                slidesPerView: 2,
            }
        }
    });
    // Collection page - collection list slider end  

    // Set same height function for the elemnets start
    function sameHeight(ele) {
        var var_height = 0;
        ele.each(function () {
            if (var_height < $(this).outerHeight()) {
                var_height = $(this).outerHeight();
            }
        });
        ele.css('min-height', var_height);
    }
    // Set same height function for the elemnets end

    sameHeight($('.testimonial-content blockquote'));

     // Collection page - to add category in the breadcrumb start
    var coll_handle = window.location.pathname;
    if (coll_handle.indexOf('/collections/') != -1) {
        var breadcrub_int = setInterval(function () {
            if ($('#header_menu_div .gm-menu').length > 0) {
                var el_el = $('#header_menu_div .gm-submenu a[href="' + coll_handle + '"]');
                if (el_el.parents('.gm-level-0').find('>a').attr('href') != coll_handle) {
                    if (el_el.length > 0 && $('nav.breadcrumb span:last-child').text().toLowerCase().trim() != el_el.parents('.gm-level-0').find('>a').text().toLowerCase().trim()) {
                        $('nav.breadcrumb .middle-one').removeClass('d-none');
                        $('nav.breadcrumb a.middle-one').text(el_el.parents('.gm-level-0').find('>a').text().toLowerCase());
                        $('nav.breadcrumb a.middle-one').attr('title', el_el.parents('.gm-level-0').find('>a').text().toLowerCase().trim());
                        $('nav.breadcrumb a.middle-one').attr('href', el_el.parents('.gm-level-0').find('>a').attr('href'));
                    }
                    clearInterval(breadcrub_int);
                }
            }
        }, 1000);
    }
    // Collection page - to add category in the breadcrumb end

    // Scroll to top arrow start
    $(".scroll-animate").click(function (e) {
        e.preventDefault();
        var data_minus = $(this).attr('data-animte-minus');
        var targt = $(this).attr('href');
        $('html, body').animate({
            // scrollTop: $(targt).offset().top - data_minus
            scrollTop: 0
        }, 'slow');
    });
    // Scroll to top arrow end

    // For the responsive JS
    $(window).resize(function () {
        if ($(window).width() < 768) {
            // For the accordion of footer start - Mobile
            // $('.footer-alignment--left h3').on('click', function () {
            //     if (!$(this).next().hasClass('active')) {
            //         $('.footer-alignment--left nav.active').find('ul').slideToggle();
            //         $('.footer-alignment--left nav.active').removeClass('active');
            //     }
            //     $(this).next().toggleClass('active');
            //     $(this).next().find('ul').slideToggle();
            // });
            // $('.footer-block-menu:first-child h3').trigger('click');
            // For the accordion of footer end - Mobile
        }
    });

    if ($(window).width() < 768) {
        // For the accordion of footer start - Mobile
        $('.footer-alignment--left h3').on('click', function () {
            if (!$(this).next().hasClass('active')) {
                $('.footer-alignment--left nav.active').find('ul').slideToggle();
                $('.footer-alignment--left nav.active').removeClass('active');
            }
            $(this).next().toggleClass('active');
            $(this).next().find('ul').slideToggle();
        });
        $('.footer-block-menu:first-child h3').trigger('click');
        // For the accordion of footer end - Mobile

        // Home page - featured blog slider start
        new Swiper('.featured-blog .swiper-container', {
            nextButton: '.featured-blog .swiper-button-next',
            prevButton: '.featured-blog .swiper-button-prev',
            slidesPerView: 2,
            spaceBetween: 8,
            breakpoints: {
                580: {
                    slidesPerView: 1.43,
                }
            }
        });
        // Home page - featured blog slider end

        // Home page - collection list slider start
        new Swiper('.template-index .collection-grid', {
            slidesPerView: 2,
            spaceBetween: 8,
            breakpoints: {
                580: {
                    slidesPerView: 1.43,
                }
            }
        });
        // Home page - collection list slider end

        // To add gap on the collection page start
        if ($('.container.blog-image-text').length > 0) {
            $('.container.blog-image-text').parent().css('padding-top', 0)
        }
        // To add gap on the collection page end

        // sameHeight($('.template-collection .indiv-product .indiv-product-title-text'));
        // sameHeight($('.homepage-section--slideshow-wrapper:nth-child(1) .flex-viewport li'));
        sameHeight($('.homepage-section--slideshow-wrapper:nth-child(1) .flex-viewport li .slider-caption'));

        // Contact form postion loadking issue start
        // var contactFormInt = setInterval(function() {
        setTimeout(function () {
            // if (window.location.hash == '#contact_form') {
            if (window.location.pathname.indexOf('challenge') != -1) {
                setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 1000);
                }, 500);
            } else if (window.location.search.indexOf('contact_posted=true') != -1) {
                $('html, body').animate({
                    scrollTop: $("#contact_form").offset().top - 250
                }, 2000);
                // clearInterval(contactFormInt);
            }
        }, 1000);
        // }, 500);  
        // Contact form postion loadking issue end

        $('.mobile-header--wrapper .mobile-side-column .header-link.search-show').on('click', function (e) {
            console.log('sds');
            e.preventDefault();
            //$('#top-search-wrapper').removeClass('expanded');
            $('#boost-sd__instant-search-container > div.boost-sd__search-bar-wrapper--mobile-style1').removeClass('boost-sd__g-hide');
            $('.boost-sd__search-bar-wrapper.boost-sd__search-bar-wrapper--mobile').removeClass('boost-sd__g-hide');
            $('#boost-sd__instant-search-container > div.boost-sd__search-bar-wrapper--mobile-style1 input').focus()
        });
        
        // Remove desktop's wishlist div on PDP start
        $('.product-medias #smartwishlist').remove();
        // Remove desktop's wishlist div on PDP end
    }

    // $(window).scroll(function() {
    //   console.log('called', $('#AjaxinateInfiniteScrolling:visible'));
    //   if($('#AjaxinateInfiniteScrolling').length > 0 && $('#AjaxinateInfiniteScrolling').text().indexOf('more') != -1) {
    //    $.getScript("https://jonesanddaughters.co/cdn/shop/t/20/assets/quickview.js", function(){
    //    console.log("Script was loaded");
    //  });
    //   }
    // });


    setTimeout(function () {
        if ($('.gm-item.gm-hidden-desktop.gm-level-0 > a > span').length > 0 && $('.gm-item.gm-hidden-desktop.gm-level-0 > a > span').text().toLowerCase().indexOf('sale') != -1) {
            $('.mobile-menu li[data-link-text="sale"]').hide();
        }
    }, 2000);

    if ($('.collection-grid .swiper-wrapper article').length <= 0) {
        $('.template-collection .homepage-sections-wrapper').hide();
        $('.collection-header-wrapper').css('padding-bottom', '60px');
        $('.collection-header-wrapper .collection-title h1').text($('.collection-header-wrapper .collection-title h1').text().replace('Shop All', ''));
    }
    $('.collection-header-wrapper .collection-title h1').text($('.collection-header-wrapper .collection-title h1').text().replace('Shop All All', 'Shop All'));

    // Show update cart total start
    setInterval(function () {
        $.ajax({
            type: 'GET',
            dataType: 'json',
            url: '/cart.js',
            success: function (cart) {
                // once you get the data from AJAX API you need to get the latest count
                let total = cart.item_count;
                if ($('#cart-error').length <= 0) {
                  $('.cart-drawer__top .cart-drawer--title sup').html('(' + total + ')');
                  $('.cart_count').html(total);
                  if(total > 0) {
                    $('.shipping-text').show();
                  } else {
                    $('.shipping-text').hide();
                  }
                } else {
                  setTimeout(function() {
                    $('.cart-drawer__top .cart-drawer--title sup').html('(' + total + ')');
                    $('.cart_count').html(total);
                    if(total > 0) {
                      $('.shipping-text').show();
                    } else {
                      $('.shipping-text').hide();
                    }
                  }, 1000);
                }
            }
        });
    }, 200);
    // Show update cart total end

    function colorSizeVarianthideshow() {
      if ($('.swatches-wrapper:eq(0) .swatch-title').text().trim().toLowerCase() == 'color' && $('.swatches-wrapper:eq(1) .swatch-title').text().trim().toLowerCase() == 'size') {
        $('[name="option-1"]').parent().hide();
        $('select[name="id"] option').each(function() {
            // console.log($(this).text().trim().split('-'));
            var var_val = $(this).text().trim().split('-');
            var color_val = var_val[0].split('/');
            if ($('[name="option-0"]:checked').val() == color_val[0].trim()) {
                // console.log('called in', color_val[0].trim())
                // console.log($('[name="option-1"][value="'+color_val[1].trim()+'"]'));
                $('[name="option-1"][value="'+color_val[1].trim()+'"]').parent().show();
            }
            // console.log(color_val[0].trim(), color_val[1].trim());
        });
        if ($('.swatches-wrapper:eq(1) .swatch div:visible input:checked').length <= 0) {
          $('.swatches-wrapper:eq(1) .swatch div:visible input').trigger('click');
        } 
      } else if ($('.swatches-wrapper:eq(0) .swatch-title').text().trim().toLowerCase() == 'size' && $('.swatches-wrapper:eq(1) .swatch-title').text().trim().toLowerCase() == 'color') {
        $('[name="option-1"]').parent().hide();
        $('select[name="id"] option').each(function() {
            // console.log($(this).text().trim().split('-'));
            var var_val = $(this).text().trim().split('-');
            var size_val = var_val[0].split('/');
            // if ($('[name="option-0"]:checked').val() == size_val[0].trim()) {
            //     // console.log('called in', size_val[0].trim())
            //     // console.log($('[name="option-1"][value="'+size_val[1].trim()+'"]'));
            //     $('[name="option-1"][value="'+size_val[1].trim()+'"]').parent().show();
            // }
            if ($('[name="option-0"]:checked').val() === size_val[0].trim()) {
                var color_combined = size_val.slice(1).join('/').trim(); 
                console.log('[name="option-1"][value="' + color_combined + '"]');
                $('[name="option-1"][value="' + color_combined + '"]').parent().show();
                }
            console.log(size_val[0].trim(), size_val[1].trim());
        });
        if ($('.swatches-wrapper:eq(1) .swatch div:visible input:checked').length <= 0) {
          $('.swatches-wrapper:eq(1) .swatch div:visible input').trigger('click');
        }
      }
      
      $('[name="option-0"]').next().find('img').hide();
      $('[name="option-1"]').next().find('img').hide();
      var option_0_val = $('[name="option-0"]:checked').val();
      var option_1_val = $('[name="option-1"]:checked').val();
      $('select[name="id"] option').each(function() {
        var var_val = $(this).text().trim().split('-');
        // console.log(var_val, 'var_val')
        if (var_val[0].indexOf(option_0_val) != -1) {
          // console.log('iffff 1');
          if ($(this).attr('data-soldout') == 'true') {
          // console.log('iffff 11', $(this).attr('data-val'));
            var rem_val_0 = $(this).attr('data-val').replace(option_0_val, '').replace('/', '').trim();
            // console.log('rem_val_0', rem_val_0, $('[name="option-0"][value="'+rem_val_0+'"]'))
            if ($('[name="option-1"][value="'+rem_val_0+'"]').length > 0) {
              // console.log('iffff 111');
              // console.log('innnn', option_0_val);
              $('[name="option-1"][value="'+rem_val_0+'"]').next().find('img').show();
            }
          }
        }
        if (var_val[0].indexOf(option_1_val) != -1) {
          // console.log('iffff 2');
          if ($(this).attr('data-soldout') == 'true') {
          // console.log('iffff 22', $(this).attr('data-val'));
            var rem_val_1 = $(this).attr('data-val').replace(option_1_val, '').replace('/', '').trim();
            // console.log('rem_val_1', rem_val_1, $('[name="option-1"][value="'+rem_val_1+'"]'))
            if ($('[name="option-0"][value="'+rem_val_1+'"]').length > 0) {
          // console.log('iffff 222');
              // console.log('innnn 1', option_1_val);
              $('[name="option-0"][value="'+rem_val_1+'"]').next().find('img').show();
            }
          }
        }
      });
    }
    colorSizeVarianthideshow($('[name="option-0"]:checked').val());
    $('.swatches-wrapper input').on('change', function() {
      colorSizeVarianthideshow($(this).val());    
    });

    $('.swatches-wrapper input').on('click', function() {
      if ($('#desktop_thumb #gallery__thumbnails_img [data-variant-image-id='+$(this).attr('data-variant-image-id')+']').length > 0) {
        $('#desktop_thumb #gallery__thumbnails_img [data-variant-image-id='+$(this).attr('data-variant-image-id')+']').trigger('click');
      }
      if ($('#mobile_thumb_img [data-variant-image-id='+$(this).attr('data-variant-image-id')+']').length > 0) {
        $('#mobile_thumb_img [data-variant-image-id='+$(this).attr('data-variant-image-id')+']').trigger('click');
      }
    });
    setTimeout(function() {
      // $('.swatches-wrapper input:checked + label').trigger('click');
      if ($('#desktop_thumb #gallery__thumbnails_img [data-variant-image-id='+$('.swatches-wrapper input:checked').attr('data-variant-image-id')+']').length > 0) {
        $('#desktop_thumb #gallery__thumbnails_img [data-variant-image-id='+$('.swatches-wrapper input:checked').attr('data-variant-image-id')+']').trigger('click');
      }
      if ($('#mobile_thumb_img [data-variant-image-id='+$('.swatches-wrapper input:checked').attr('data-variant-image-id')+']').length > 0) {
        $('#mobile_thumb_img [data-variant-image-id='+$('.swatches-wrapper input:checked').attr('data-variant-image-id')+']').trigger('click');
      }
    }, 1000);

  //   var test = setInterval(function() {
  //     console.log('innnn');
  // if ($('#boost-sd-widget-homepage-215172 .boost-sd__recommendation .boost-sd__prev-button button').length > 0) {  
  //   console.log('innnn 2111');
  //     $('#boost-sd-widget-homepage-215172 .boost-sd__recommendation .boost-sd__prev-button button').trigger('click');
  //   clearInterval(test);
  //   }
  //     }, 500);

    $('.template-collection .homepage-collection-grid-inner .grid-image .grid-image--centered').removeClass('same-image');
    if ($('.template-collection .homepage-collection-grid-inner .grid-image .grid-image--centered .aspect-ratio').length <= 0) {
        $('.template-collection .homepage-collection-grid-inner .grid-image .grid-image--centered').addClass('same-image');
    }
});


// $('.homepage-section--featured-products-wrapper').children().each(function(){
//   var index1 = $(this).index();
//   console.log(index1,'index1');

    // $('.row .swiper-container- .row- .grid__item').each(function(){

    //   var index = $(this).index();
      
    //   if ( $('.row .swiper-container- .row- .grid__item').length > 3){
    //     console.log(index,'helloohellooooo');
    //     $(this).parent('.swiper-wrapper').parent('.swiper-slider').parent('.col-md-12').children('.justify-content-between').children('.swiper-buttons').css('visibility','visible');
    //   }
    //   else{
    //     console.log('jdskfsdf');
    //      $(this).parent('.swiper-wrapper').parent('.swiper-slider').parent('.col-md-12').children('.justify-content-between').children('.swiper-buttons').css('visibility','hidden');
    //   }
      
    // })
 // })

setTimeout(function(){
  $(".gift--page").each(function(){
    var prev = $(this).find(".swiper-buttons .swiper-button-prev").hasClass('swiper-button-disabled');
    var next = $(this).find(".swiper-buttons .swiper-button-next").hasClass('swiper-button-disabled');
    if(prev && next){
      $(this).find(".swiper-buttons .swiper-button-prev").hide();
       $(this).find(".swiper-buttons .swiper-button-next").hide();
    }
})
},1000)










$(window).on('load', function () {
    setTimeout(function () {
        var cust_url = window.location.href;
        var str2 = 'customer';

        if (cust_url.includes(str2)) {
            $('html, body').animate({
                scrollTop: ($("#contact_form").offset().top) - 150
            }, 100);
        }
    }, 500);
});